const items = (that) => [
    {
        get enabled() {
            return that && that.checkPermission(["prepared.update", "prepared.delete", "prepared.create"]);
        },
        key: "templates",
        label: that?.$t(`plans.readyContents`) || "Templates",
        icon: {
            type: "material-icons",
            name: "bolt",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission("welcome.get");
        },
        key: "system-messages",
        label: that?.$t(`message.welcomeMessages`) || "Welcome Messages",
        icon: {
            type: "material-icons",
            name: "waving_hand",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission("catalog.get");
        },
        key: "catalog",
        label: that?.$t(`message.catalogCategories`) || "Catalog",
        icon: {
            type: "material-icons",
            name: "category",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission("bannedWord.get");
        },
        key: "forbidden-inputs",
        label: that?.$t(`message.bannedWords`) || "Banned Words",
        icon: {
            type: "material-icons",
            name: "keyboard",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission(["tags.update", "tags.delete", "tags.create"]);
        },
        key: "tags",
        label: that?.$t(`message.tags`) || "Tags",
        icon: {
            type: "material-icons",
            name: "label",
        },
    },
];

export default items;
